import { Paper, Typography } from '@mui/material';

/**
 * Componente de cartão de resumo reutilizável
 * 
 * @component
 * @param {Object} props - Propriedades do componente
 * @param {number|string} props.valor - Valor numérico ou textual a ser exibido
 * @param {string} props.titulo - Título descritivo do cartão
 * 
 * @returns {React.ReactElement} Cartão de resumo estilizado
 * 
 * @example
 * // Uso básico
 * <ResumoCard valor={42} titulo="Resumos enviados" />
 */
export default function ResumoCard({ valor, titulo }) {
  return (
    // Componente Paper do Material-UI para efeito de cartão
    <Paper
      sx={{
        // Preenchimento interno
        p: 2,
        // Alinhamento central do conteúdo
        textAlign: 'center',
        // Bordas arredondadas
        borderRadius: 2,
        // Sombra sutil para profundidade
        boxShadow: 3,

        transition: 'all 0.3s ease',
        
        '&:hover': {
          boxShadow: '0 4px 15px rgba(0,0,0,0.12)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      {/* Valor principal em destaque */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 'bold',
          fontSize: '2.5rem',
          mb: 1,
          color: '#764ba2',
        }}
      >
        {valor}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: 'text.secondary',
          opacity: 0.8,
        }}
      >
        {titulo}
      </Typography>
    </Paper>
  );
}
